import { render, staticRenderFns } from "./gameRulesTab.vue?vue&type=template&id=8181bdd4&scoped=true&"
import script from "./gameRulesTab.vue?vue&type=script&lang=js&"
export * from "./gameRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./gameRulesTab.vue?vue&type=style&index=0&id=8181bdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8181bdd4",
  null
  
)

export default component.exports